import { Injectable } from '@angular/core';
import { ColumnDefinition, ColumnDefinitions, ColumnGroup } from './column-group.class';

@Injectable({ providedIn: 'root' })
export class LicenceColumns extends ColumnGroup {
  public constructor() {
    super();
  }

  protected columnDefinitions: ColumnDefinitions = {
    indexingLicenceStatus: {
      width: 120,
    },
    driverLicenceView: {
      width: 140,
      cellRenderer: 'viewLicenceResultsModalButtonComponent',
    },
  };
}
